import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *   ui: import("./ui").PayerUIReducer,
 *   data: import("./data").PayerDataEntity
 * }} PayerReducer
 */

export default combineReducers({
  data,
  ui,
});
